export const Image = () => {
  return (
    <div className="
      relative
      w-full
      h-[560px]
      rounded-[34px]
      overflow-hidden
      shadow-[0px_35px_90px_rgba(0,0,0,0.18)]
    ">

      <img
        src="/images/Webp/AboutUs.webp"
        alt="People enjoying deals"
        className="w-full h-full object-cover "
      />


      {/* vignette */}
      <div className="
        absolute inset-0
        bg-gradient-to-t
        from-black/50
        via-black/10
        to-transparent
      " />


      {/* overlay card */}
      <div className="absolute left-10 right-10 bottom-10">

        <div className="
          bg-black/60
          backdrop-blur-lg
          rounded-[24px]
          px-8
          py-7
          shadow-[0px_20px_70px_rgba(0,0,0,0.45)]
        ">

          <div className="border-l-[3px] border-white/40 pl-6">

            <p className="
              text-white/90
              text-[16px]
              leading-[28px]
              font-light
            ">
              Support the local businesses you love and get rewarded for it. From your morning coffee to weekend dinners, we connect you with authentic deals and valuable points so you can afford to do more together.
            </p>

          </div>

        </div>

      </div>

    </div>
  );
};